// The Offer tab's own words (lane B8, S12): the ones the design system's label modules do not already carry. Each
// quotes the glossary line (G §12 reference check, offer package, offer; G §9 scheduling) it is taken from;
// labels.test.mjs finds this module (a lane folder under src/views) and checks every quote, text and status, and
// b8-words.test.mjs checks that the offer screens draw no other words. Words the shared modules carry (the offer
// chain, G §17 verbs, the reason box's fields, the tab names, the page title) are imported from @/mc, never redefined.

import { defineLabels } from "@/mc/labels";

const NEGOTIATION = "\"Dedicated Offer Negotiation status and substates.\"";
const COUNTER_ROW = "| Counter / request |";
const CAPTURE = "\"Capture verbal/written dates, counter/request, approval, candidate decision, accepted/declined dates.\"";
const DECISION_ROW = "| Candidate decision |";
const ACCEPTED_DATE = "\"Accepted date is separate from Filled.\"";
const NEXT_PATH_ROW = "| Next path (alternate to offer / continue / reopen / close) |";
const OFFER_CALL_ROW = "| Offer call | Meeting template \"offer call\". |";

/** The Offer Negotiation card (DC-202): its title and the dated facts BRD §3.20 asks it to capture. */
export const OFFER_TAB_LABELS = /* @__PURE__ */ defineLabels({
  offerNegotiation: { text: "Offer Negotiation" },
  counterRequest: { text: "Counter / request" },
  approval: { text: "Approval" },
  candidateDecision: { text: "Candidate decision" },
  acceptedDate: { text: "Accepted date" },
  nextPath: { text: "Next path" },
  offerCall: { text: "Offer call" },
});

/** The dialogs' rule sentences: why a confirm stays dashed, and the notes field's audit hint. */
export const OFFER_RULE_LABELS = /* @__PURE__ */ defineLabels({
  declineReasonRequired: { text: "Offer decline reason required." },
  nextPathRequired: { text: "Decline requires next-path selection." },
  cancelRequires: { text: "final notes/reporting category" 


},
  noInternalNotes: { text: "Candidate-facing status contains no internal notes." },
});
